import React from 'react';
import ImageCarousel, { CarouselImage } from './Carousel';

interface DesignStylesCarouselProps {
  images: CarouselImage[];
}

const DesignStylesCarousel: React.FC<DesignStylesCarouselProps> = ({ images }) =>
  <ImageCarousel images={images} className="design-styles-carousel"/>;

export default DesignStylesCarousel; 